import api from "../services/api";

export const CreatePayment = async () =>{
    try {

    const token = localStorage.getItem("@Auth:token");
    const response = await api.post(`/create-checkout-session`, {
          headers: {
                Authorization: `Bearer ${JSON.parse(token)}`,
          },
      });
      console.log(JSON.parse(token))
      return response
  } catch (error) {
      console.error('Erro ao fazer pagamento:', error.request._response);
      console.log(error)
  }
}
export const CreateCheckoutSession = async (id) =>{
    try {

    const token = localStorage.getItem("@Auth:token");
    const response = await api.post(`/create-checkout/${id}`,  {
          headers: {
                Authorization: `Bearer ${JSON.parse(token)}`,
          },
      });
      console.log(JSON.parse(token))
      return response
  } catch (error) {
      console.error('Erro ao fazer pagamento:', error.request._response);
      console.log(error)
  }
}
export const OpenCustomerPortal = async (id) =>{
    try {

    const token = localStorage.getItem("@Auth:token");
    const response = await api.post(`/create-customer-portal-session/${id}`,  {
          headers: {
                Authorization: `Bearer ${JSON.parse(token)}`,
          },
      });
      console.log(JSON.parse(token))
      return response
  } catch (error) {
      console.error('Erro ao fazer pagamento:', error.request._response);
      console.log(error)
  }
}
export const CreateSubscription = async (paymentMethodId) =>{
    try {

    const token = localStorage.getItem("@Auth:token");
    const response = await api.post(`/create-subscription`, paymentMethodId, {
          headers: {
                Authorization: `Bearer ${JSON.parse(token)}`,
          },
      });
      console.log(JSON.parse(token))
      return response
  } catch (error) {
      console.error('Erro ao criar assinatura:', error.request._response);
      console.log(error)
  }
}

// Buscar transações de um usuário específico
export const getUserTransactions = async (userId) => {
    try {
        const response = await api.get(`/transactions/${userId}`);
        return response;
    } catch (error) {
        console.error('Erro ao buscar transações do usuário:', error?.response?.data);
        throw error;
    }
}

// Buscar todas as transações
export const getAllTransactions = async () => {
    try {
        const token = localStorage.getItem("@Auth:token");
        const response = await api.get(`/all-transactions`, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`,
            },
        });
        return response;
    } catch (error) {
        console.error('Erro ao buscar todas as transações:', error?.response?.data);
        throw error;
    }
}

// Números da página Relatórios, já calculados no backend (antes baixava todas as transações)
export const getTransactionStats = async () => (await api.get('/admin/transactions/stats')).data;
